import React, { useState, useEffect } from 'react'


const QuestionInput = ({ btnDisabled, resetInput = false, onSubmit }) => {
  const [input, setInput] = useState('');
  const onChange = (e) => setInput(e.target.value);

  useEffect(() => {
    if (resetInput) { setInput(''); }
  }, [ resetInput ]);
  
  return (
    <fieldset className='question-inputs'>
      <section className='inputs d-flex align-items-center'>
        <input
          type='text'
          name='input'
          className='question-input ua-input'
          value={input}
          placeholder='請直接提問'
          onChange={onChange}
        />

        <button
          type='button'
          className={`question-submit submit ua-btn default
              ${(btnDisabled || input.length === 0) ? 'disabled' : ''}`}
          disabled={btnDisabled}
          value={input}
          onClick={onSubmit}
        >
          <i className='fa fa-paper-plane'/>
        </button>
      </section>
    </fieldset>
  );
}


export { QuestionInput }
